<template>
  <div class="product-details-content-setup-step-02">
    <b-tabs>
      <b-tab :title="tab1Title" active class="pt-6">
        <tab-color :form="form" :errors="errors" />
      </b-tab>
      <b-tab :title="tab2Title" class="pt-6">
        <tab-login-image :form="form" :errors="errors" />
      </b-tab>
      <b-tab title="Logotipo" class="pt-6">
        <tab-logo :form="form" :errors="errors" />
      </b-tab>
      <b-tab title="Capa" class="pt-6">
        <tab-cover :form="form" :errors="errors" />
      </b-tab>
      <b-tab title="Placeholders" class="pt-6">
        <tab-placeholder :form="form" :errors="errors" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TabColor from "@/components/product/details/content/customize/TabColor.vue";
import TabCover from "@/components/product/details/content/customize/TabCover.vue";
import TabLoginImage from "@/components/product/details/content/customize/TabLoginImage.vue";
import TabLogo from "@/components/product/details/content/customize/TabLogo.vue";
import TabPlaceholder from "@/components/product/details/content/customize/TabPlaceholder.vue";

export default {
  components: {
    TabPlaceholder,
    TabLoginImage,
    TabLogo,
    TabColor,
    TabCover
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { isMobile: window.innerWidth < 991 };
  },
  mounted() {
    document.addEventListener("resize", e => {
      this.isMobile = e.target.innerWidth < 991;
    });
  },
  computed: {
    tab1Title() {
      return this.isMobile ? "Fundo" : "Cor de fundo";
    },
    tab2Title() {
      return this.isMobile ? "Login" : "Imagens do Login";
    }
  }
};
</script>
